import React from "react";
import { checkIsVn } from "../../templates/helper/getConstantStringByLanguage";

const SelectGradeUpgrade = ({ item, isAlreadyPremium, handleSelectLevel }) => {
  return (
    <div
      className="select-grade-upgrade-item is-uppercase has-text-weight-bold is-flex is-align-items-center is-justify-content-center is-align-self-stretch is-relative is-clickable"
      onClick={() => {
        if (!isAlreadyPremium) {
          handleSelectLevel(item?.level, item?.key);
        }
      }}
      style={{
        backgroundImage: isAlreadyPremium
          ? "url('/images/upgrades/select_grade_level_upgrade.png')"
          : "url('/images/upgrades/select_grade_level_not_upgrade.png')",
        backgroundPosition: "center",
        width: isAlreadyPremium ? "15rem" : "14.5rem",
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        fontSize: checkIsVn() ? "1.125rem" : "1.125rem",
        height: isAlreadyPremium ? "4rem" : "3rem",
        padding: "0.625rem 0rem",
        color: isAlreadyPremium ? "#FAFBFC" : "#0A2A66",
      }}
    >
      {isAlreadyPremium && (
        <>
          <div
            className="is-uppercase has-text-weight-bold is-flex is-align-items-center is-justify-content-center has-text-kurio-main-color-white has-background-kurio-main-color-purple"
            style={{
              position: "absolute",
              left: "6.375rem",
              top: "-0.5625rem",
              padding: "0.125rem 0.5rem",
              height: "0.875rem",
              borderRadius: "0.5rem 0.5rem 0rem 0rem",
              border: "1px solid #B5C2FF",
            }}
          >
            <img src="images/upgrades/max_tag.svg" alt="" />
          </div>
          <div
            style={{
              position: "absolute",
              left: "calc((100% - 4rem)/2)",
              bottom: "-0.75rem",
            }}
          >
            <img
              style={{ width: "4rem", objectFit: "cover" }}
              src="images/upgrades/union_upgrade.svg"
              alt=""
            />
          </div>
        </>
      )}
      <div
        className="is-flex is-align-items-center is-justify-content-center is-flex-wrap-wrap"
        style={{ width: "100%", gap: "0.5rem" }}
      >
        <p>{item.name}</p>
        {!isAlreadyPremium && (
          <p
            className="has-text-kurio-main-color-purple is-uppercase"
            style={{
              background: "#DDD5F5",
              padding: "0.125rem 0.25rem",
              borderRadius: "0.5rem",
              fontSize: "0.75rem",
              lineHeight: "150%",
            }}
          >
            {item.sale}
          </p>
        )}
      </div>
    </div>
  );
};

export default SelectGradeUpgrade;
